module.exports = __webpack_public_path__ + "static/media/SteeringFpIImageOnlyViz95.58389b87.mp4";